'use strict';

// Script is deferred — DOM is fully parsed and Alpine has already
// initialised (alpine.min.js runs before this file in defer order).

const initSwipers = () => {
    // Сайдбар главной активен → контент уже, слайдеры показывают меньше карточек
    const hasSidebar = !!document.querySelector('.home--has-sidebar');

    const heroEl = document.querySelector('.h-slider-main');
    if (heroEl) {
        const useAutoplay = heroEl.dataset.autoplay !== '0';
        const timer = (parseInt(heroEl.dataset.timer, 10) || 5) * 1000;
        const slideCount = parseInt(heroEl.dataset.slides, 10) || 0;
        const hasMultiple = slideCount > 1;
        const syncSlideColor = (sw) => {
            const slide = sw.slides[sw.activeIndex];
            if (slide) {
                const c = getComputedStyle(slide).getPropertyValue('--slide-color').trim();
                if (c) heroEl.style.setProperty('--slide-color', c);
            }
        };
        new Swiper('.h-slider-main', {
            loop: hasMultiple,
            autoplay: hasMultiple && useAutoplay ? { delay: timer, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
            speed: 600,
            pagination: hasMultiple ? { el: '.h-slider-main__pagination', clickable: true } : false,
            navigation: hasMultiple ? { prevEl: '.h-slider-main__prev', nextEl: '.h-slider-main__next' } : false,
            on: { init: syncSlideColor, slideChange: syncSlideColor },
        });
    }

    const promosEl = document.querySelector('.h-promos__swiper');
    if (promosEl) {
        const promoCount = parseInt(promosEl.querySelector('[data-count]')?.dataset.count, 10) || 1;
        new Swiper('.h-promos__swiper', {
            slidesPerView: promoCount === 1 ? 1 : 1.8,
            spaceBetween: 1,
            breakpoints: {
                768: { enabled: false,  spaceBetween: 1 },
                1024: { enabled: false,  spaceBetween: 0 },
            },
        });
    }

    if (document.querySelector('.h-cats__swiper')) {
        const catNav = document.querySelector('.h-cats__nav');
        const catExpanded = !!document.querySelector('.h-cats__swiper').closest('.h-cats--expanded');
        const catSwiper = new Swiper('.h-cats__swiper', {
            // мобилка: сайдбар скрыт (≤1024), поэтому всегда 2.5 — как без сайдбара;
            // десктоп (≥768) → 'auto', ширину слайда задаёт CSS (с учётом сайдбара)
            slidesPerView: 2.5,
            spaceBetween: 10,
            freeMode: true,
            watchOverflow: true,
            navigation: { nextEl: '.h-cats__nav--next', prevEl: '.h-cats__nav--prev' },
            breakpoints: {
                768: { slidesPerView: 'auto' },
            },
        });
        if (catNav && catSwiper.isLocked) {
            catNav.style.display = 'none';
        }
    }

    // ── Products swiper (supports tabs + stack mode) ──
    window.__initProdSwiper = (el, navEl) => {
        const nav = navEl || document.querySelector('.h-prods-nav');
        const prevBtn = nav ? nav.querySelector('.h-prods-nav__prev') : null;
        const nextBtn = nav ? nav.querySelector('.h-prods-nav__next') : null;
        const sw = new Swiper(el, {
            slidesPerView: 2,
            spaceBetween: 8,
            watchOverflow: true,
            navigation: prevBtn && nextBtn ? { prevEl: prevBtn, nextEl: nextBtn } : false,
            breakpoints: {
                768:  { slidesPerView: 3,  spaceBetween: 8 },
                1025: { slidesPerView: hasSidebar ? 3 : 4,  spaceBetween: 8 },
                1225: { slidesPerView: hasSidebar ? 4 : 5,  spaceBetween: 8 },
            },
            on: {
                resize(sw) {
                    if (nav && el.offsetParent) nav.classList.toggle('is-hidden', sw.isLocked);
                },
                lock() {
                    if (nav && el.offsetParent) nav.classList.add('is-hidden');
                },
                unlock() {
                    if (nav && el.offsetParent) nav.classList.remove('is-hidden');
                },
            },
        });
        if (nav && sw.isLocked) nav.classList.add('is-hidden');
        return sw;
    };

    // Init: tab mode — only default tab; stack mode — all slider grids
    const defaultTab = document.querySelector('[data-tab-default]');
    if (defaultTab) {
        const el = defaultTab.querySelector('.h-prods-grid__swiper');
        const nav = document.querySelector('.h-prods-nav');
        if (el) window.__initProdSwiper(el, nav);
        else if (nav) nav.classList.add('is-hidden');
    } else {
        document.querySelectorAll('[data-slider]').forEach(wrap => {
            const el = wrap.querySelector('.h-prods-grid__swiper');
            const tabId = wrap.dataset.tab;
            const nav = document.querySelector(`[data-nav-for="${tabId}"]`);
            if (el) window.__initProdSwiper(el, nav);
        });
    }

    // ── Reviews swiper ──
    const revEl = document.querySelector('[data-reviews-slider]');
    if (revEl) {
        const revNav = document.querySelector('[data-nav-for="reviews"]');
        const revPrev = revNav ? revNav.querySelector('.h-reviews__nav-btn--prev') : null;
        const revNext = revNav ? revNav.querySelector('.h-reviews__nav-btn--next') : null;
        const revSw = new Swiper(revEl, {
            slidesPerView: 1.15,
            spaceBetween: 12,
            watchOverflow: true,
            navigation: revPrev && revNext ? { prevEl: revPrev, nextEl: revNext } : false,
            breakpoints: {
                768:  { slidesPerView: 2, spaceBetween: 16 },
                1025: { slidesPerView: hasSidebar ? 2 : 3, spaceBetween: 16 },
            },
        });
        if (revNav && revSw.isLocked) revNav.style.display = 'none';
    }

    // Init: custom block product swipers
    document.querySelectorAll('[data-cb-slider]').forEach(el => {
        const cbId = el.dataset.cbSlider;
        const nav = document.querySelector(`[data-nav-for="${cbId}"]`);
        window.__initProdSwiper(el, nav);
    });

};

// defer гарантирует, что DOM готов; но на случай если файл подключён
// без defer (например в Webasyst) — страхуемся через DOMContentLoaded.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipers);
} else {
    initSwipers();
}
